// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { contactSchema } from '@/contact/api/types';
import { z } from 'zod';

const contactResponseSchema = z
  .object({
    data: contactSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, contact: data }));

type ContactResponse = z.infer<typeof contactResponseSchema>;

export async function getContact(contactKey: string): Promise<ContactResponse> {
  const url = `/v1/contact/${contactKey}`;
  const response = await api.get(url);

  return parseResponse(contactResponseSchema, response.data, {
    schemaName: 'Contact',
    endpoint: url,
  });
}
